import { Action } from "redux";

import type { TypedObject } from "@multiweb/types/react";
import { REMOVE_RIGHTS_FOR_COMPONENTS, SET_RIGHTS_FOR_COMPONENTS, SET_RIGHTS_INTERNAL } from "./constants";

/**
 * Definice stavu kolekci vyhodnocených práv komponent.
 */
export type RightsState = TypedObject<IComponentRightsState>;

/**
 * Typ stavu obsahujcí práva pro jednu komponentu.
 */
export interface IComponentRightsState {
    readonly visible: boolean;
    readonly enabled: boolean;
    readonly required: boolean;
    readonly postponedRequired: boolean;
    readonly recommended: boolean;
}

/**
 * Typ obsahu pro akci hromadného nastavení práv komponentám.
 */
export type SetRightsForComponentsPayload = ReadonlyArray<{
    /** Id komponenty, pro kterou se nastavují práva. */
    readonly id: string;
    /** Práva komponenty. */
    readonly rights: Partial<IComponentRightsState>;
}>;

/**
 * Typ akce pro hromadné nastavení práv komponentám.
 */
export interface ISetRightsForComponentsAction extends Action<typeof SET_RIGHTS_FOR_COMPONENTS> {
    readonly payload: SetRightsForComponentsPayload;
}

export class ISetRightsForComponentsAction {
    public static [Symbol.hasInstance](instance: any): boolean {
        return instance?.type === SET_RIGHTS_FOR_COMPONENTS;
    }
}

/**
 * Typ interní akce pro nastavení práv jedné komponentě.
 */
export interface ISetRightsInternal extends Action<typeof SET_RIGHTS_INTERNAL> {
    readonly payload: Partial<IComponentRightsState>;
}

export class ISetRightsInternal {
    public static [Symbol.hasInstance](instance: any): boolean {
        return instance?.type === SET_RIGHTS_INTERNAL;
    }
}

/**
 * Typ obsahu akce pro odstraňování práv komponent. Pole identifikátorů komponent, jejichž práva se odstraňují.
 */
export type RemoveRightsForComponentsPayload = ReadonlyArray<string>;

/**
 * Typ akce pro hromadné odstranění práv komponent.
 */
export interface IRemoveRightsForComponents extends Action<typeof REMOVE_RIGHTS_FOR_COMPONENTS> {
    readonly payload: RemoveRightsForComponentsPayload;
}

export class IRemoveRightsForComponents {
    public static [Symbol.hasInstance](instance: any): boolean {
        return instance?.type === REMOVE_RIGHTS_FOR_COMPONENTS;
    }
}
